import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { StandaloneSearchBox } from '@react-google-maps/api';
import { useGoogleTranslator } from '@/hooks/useGoogleTranslator';
import styles from './Autocomplete.styles';
import { Location } from '@/graphql/types';

interface Props {
  updateMapPosition: (location: Location) => void;
  textSearch: string;
  setTextSearch: (TextSearch: string) => void;
  setLocalArea: (localArea: string) => void;
  hasError: boolean;
}

export const Autocomplete = ({
  updateMapPosition,
  textSearch,
  setTextSearch,
  setLocalArea,
  hasError,
}: Props) => {
  const [searchBox, setSearchBox] = useState(null);
  const placeholderTranslated = useGoogleTranslator(
    'Search by City, Street Address, or Zip code',
  );
  const labelTranslated = useGoogleTranslator('Center of Map');
  const messageErrorTranslated = useGoogleTranslator('You missed this field.');
  const handlePlaceChanged = () => {
    // @ts-ignore
    const [place] = searchBox?.getPlaces();

    if (place) {
      const city = place.address_components.find(address =>
        address.types.includes('administrative_area_level_2'),
      );
      if (city) {
        setLocalArea(city.long_name);
      }

      setTextSearch(place.name);
      updateMapPosition({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    }
  };
  const onSBLoad = ref => {
    setSearchBox(ref);
  };

  const onSearchChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => setTextSearch(event.target.value);

  return (
    <StandaloneSearchBox
      // eslint-disable-next-line no-return-assign
      onLoad={onSBLoad}
      onPlacesChanged={handlePlaceChanged}
    >
      <TextField
        label={labelTranslated}
        placeholder={placeholderTranslated}
        fullWidth
        variant="standard"
        size="small"
        value={textSearch || ''}
        onChange={onSearchChange}
        className={styles.textfield}
        error={hasError}
        helperText={hasError ? messageErrorTranslated : null}
        data-testid="autocompleteInput"
      />
    </StandaloneSearchBox>
  );
};
